import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const LoginRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  authService.login();
  return false;
};
